import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminOperations.css";
import { obtenerListadoMatriculasAlumnos, subirCertificado } from "./constants";

export const CrearCertificado = () => {
  const [archivo, setArchivo] = useState(null);
  const [matriculaAlumno, setMatriculaAlumno] = useState("");
  const [alumnos, setAlumnos] = useState([]);
  const [cargandoAlumnos, setCargandoAlumnos] = useState(true);
  const [resultado, setResultado] = useState(null);
  const [estadoCarga, setEstadoCarga] = useState(null);
  const [mensajeCarga, setMensajeCarga] = useState("");
  const [porcentajeCarga, setPorcentajeCarga] = useState(0);
  const inputArchivo = useRef(null);
  const navigate = useNavigate();
  const estaSubiendo = estadoCarga === "subiendo";

  useEffect(() => {
    const cargarAlumnos = async () => {
      try {
        const response = await axios.get(obtenerListadoMatriculasAlumnos);
        const listado = response.data?.data?.alumnos ?? [];
        setAlumnos(Array.isArray(listado) ? listado : []);
      } catch (error) {
        console.error("Error al cargar alumnos:", error);
        setAlumnos([]);
        setResultado({
          tipo: "error",
          mensaje: "No fue posible cargar la lista de alumnos.",
        });
      } finally {
        setCargandoAlumnos(false);
      }
    };

    cargarAlumnos();
  }, []);

  const handleSubmitPDF = async (event) => {
    event.preventDefault();
    setResultado(null);

    const alumnoValido = alumnos.some(
      (alumno) => alumno.matricula === matriculaAlumno,
    );
    if (!archivo || !alumnoValido) {
      setResultado({
        tipo: "warning",
        mensaje: "Selecciona un alumno válido y un archivo PDF.",
      });
      return;
    }

    setEstadoCarga("subiendo");
    setMensajeCarga("Subiendo la constancia...");
    setPorcentajeCarga(0);

    const formData = new FormData();
    formData.append("archivo", archivo);
    formData.append("matricula_alumno", matriculaAlumno);

    try {
      const response = await axios.post(subirCertificado, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) {
            return;
          }

          const porcentaje = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setPorcentajeCarga(porcentaje);
          setMensajeCarga(
            porcentaje === 100
              ? "Archivo enviado. Procesando en el servidor..."
              : "Subiendo la constancia...",
          );
        },
      });

      if (response.data?.success === false) {
        setEstadoCarga("error");
        setMensajeCarga(
          response.data.message || "No se pudo cargar la constancia.",
        );
        return;
      }

      setEstadoCarga("exito");
      setMensajeCarga(
        response.data?.message || "La constancia se cargó correctamente.",
      );
      setArchivo(null);
      setMatriculaAlumno("");
      if (inputArchivo.current) {
        inputArchivo.current.value = "";
      }
    } catch (error) {
      console.error("Error al subir la constancia:", error);
      setEstadoCarga("error");
      setMensajeCarga(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "No se pudo cargar la constancia.",
      );
    }
  };

  const handleCerrarResultado = () => {
    if (!estaSubiendo) {
      setEstadoCarga(null);
      setMensajeCarga("");
    }
  };

  return (
    <div className="admin-operation-page">
      <main className="admin-operation-container admin-operation-container-narrow">
        <header className="admin-operation-header">
          <p className="admin-operation-eyebrow">Documentación académica</p>
          <h1>Subir constancia</h1>
          <p>
            Selecciona al alumno y carga su constancia en formato PDF para que
            quede disponible en la plataforma.
          </p>
        </header>

        <form className="admin-operation-panel" onSubmit={handleSubmitPDF}>
          <div className="admin-operation-grid">
            <section className="admin-operation-card">
              <div className="admin-operation-card-heading">
                <span>1</span>
                <div>
                  <h2>Selecciona al alumno</h2>
                  <p>Busca por matrícula o nombre.</p>
                </div>
              </div>
              <div className="admin-operation-field">
                <label htmlFor="certificate-student">Alumno</label>
                <input
                  id="certificate-student"
                  type="text"
                  list="certificate-students"
                  value={matriculaAlumno}
                  onChange={(event) => setMatriculaAlumno(event.target.value)}
                  placeholder={
                    cargandoAlumnos
                      ? "Cargando alumnos..."
                      : "Escribe una matrícula"
                  }
                  disabled={cargandoAlumnos || estaSubiendo}
                  autoComplete="off"
                  required
                />
                <datalist id="certificate-students">
                  {alumnos.map((alumno) => (
                    <option
                      key={alumno.id ?? alumno.matricula}
                      value={alumno.matricula}
                    >
                      {[alumno.nombre, alumno.apellido]
                        .filter(Boolean)
                        .join(" ")}
                    </option>
                  ))}
                </datalist>
              </div>
            </section>

            <section className="admin-operation-card">
              <div className="admin-operation-card-heading">
                <span>2</span>
                <div>
                  <h2>Selecciona el PDF</h2>
                  <p>La constancia debe estar en formato .pdf.</p>
                </div>
              </div>
              <div className="admin-operation-field">
                <label htmlFor="certificate-file">Archivo de constancia</label>
                <input
                  ref={inputArchivo}
                  className="admin-operation-file"
                  id="certificate-file"
                  type="file"
                  onChange={(event) =>
                    setArchivo(event.target.files[0] || null)
                  }
                  accept=".pdf,application/pdf"
                  disabled={estaSubiendo}
                  required
                />
                {archivo && <small>Archivo seleccionado: {archivo.name}</small>}
              </div>
            </section>
          </div>

          {resultado && (
            <div
              className={`admin-operation-status admin-operation-status-${resultado.tipo}`}
              role="status"
            >
              {resultado.mensaje}
            </div>
          )}

          <div className="admin-operation-actions">
            <button
              className="admin-operation-button"
              type="submit"
              disabled={cargandoAlumnos || alumnos.length === 0 || estaSubiendo}
            >
              {estaSubiendo ? "Subiendo constancia..." : "Subir constancia"}
            </button>
            <button
              className="admin-operation-button admin-operation-button-secondary"
              type="button"
              onClick={() => navigate("/admin-home")}
              disabled={estaSubiendo}
            >
              Regresar al inicio
            </button>
          </div>
        </form>
      </main>

      {estadoCarga && (
        <div className="admin-operation-modal-overlay" role="presentation">
          <div
            className="admin-operation-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="certificate-upload-title"
          >
            <h2 id="certificate-upload-title">
              {estadoCarga === "subiendo" && "Carga en proceso"}
              {estadoCarga === "exito" && "Constancia cargada"}
              {estadoCarga === "error" && "No se pudo completar la carga"}
            </h2>
            <p>{mensajeCarga}</p>

            {estaSubiendo && (
              <>
                <div className="admin-operation-progress">
                  <div style={{ width: `${porcentajeCarga}%` }} />
                </div>
                <p>
                  {porcentajeCarga > 0
                    ? `${porcentajeCarga}% enviado`
                    : "Preparando archivo..."}
                </p>
              </>
            )}

            {!estaSubiendo && (
              <button
                className="admin-operation-button"
                type="button"
                onClick={handleCerrarResultado}
              >
                Cerrar
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
